import { ChargeMapContext } from '@/pages/chargermap/components/chargerMap/index.model'

export const setMapStyleByConfig = (context: ChargeMapContext, config: any) => {
  if (config?.custom_style?.show && config?.custom_style?.properties?.url) {
    const url = config.custom_style.properties.url
    window
      .fetch(url)
      .then((response) => response.json())
      .then((style) => {
        Array.isArray(style) && context.setMapStyle(style)
      })
  } else {
    context.setMapStyle()
  }
}
